import { render, staticRenderFns } from "./ReleasePromotionalTextsReadOnlyPanel.vue?vue&type=template&id=252fe27a"
import script from "./ReleasePromotionalTextsReadOnlyPanel.vue?vue&type=script&lang=js"
export * from "./ReleasePromotionalTextsReadOnlyPanel.vue?vue&type=script&lang=js"
import style0 from "./ReleasePromotionalTextsReadOnlyPanel.vue?vue&type=style&index=0&id=252fe27a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports